module.exports = __webpack_public_path__ + "static/media/2.62754a97.svg";